import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Environment } from '@imaginelearning/web-api-core';
import EnvironmentImpl from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AuthenticateComponent } from './components/authenticate/authenticate.component';
import { InitiateComponent } from './components/initiate/initiate.component';
import { SSOComponent } from './components/sso/sso.component';
import { LoggingService } from './services/logging.service';
import * as i0 from "@angular/core";
export class AppModule {
    static { this.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [AppComponent] }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            { provide: Environment, useFactory: () => new EnvironmentImpl() },
            Title,
            LoggingService,
            provideHttpClient(withInterceptorsFromDi())
        ], imports: [CommonModule, AppRoutingModule, BrowserModule, BrowserAnimationsModule] }); }
}
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AppModule, { declarations: [AppComponent, AuthenticateComponent, InitiateComponent, SSOComponent], imports: [CommonModule, AppRoutingModule, BrowserModule, BrowserAnimationsModule] }); })();
